module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-chevy.e0fb4be0.jpg";